<template>
  <div class="empty-data">
    <div class="empty-inner">
      <svg-icon :name="icon"></svg-icon>
      <span>{{ emptyTitle }}</span>
    </div>
  </div>
</template>

<script>
import i18n from '../lang/index'
export default { 
  name: 'empty',
  props: {
    icon: {
      type: String,
      default: 'no-data'
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    emptyTitle() {
      let defaultTitle = localStorage.getItem("language") == 'en' ? 'No Data':'暂无数据'
      return this.title || defaultTitle
    }
  },
}
</script>

<style lang="scss" scoped>
.empty-data {
  padding: 30px 0;
  text-align: center;
  line-height: 1;
  // height: 100%;
  position: relative;
  // .empty-inner{
  //   position: relative;
  //   top: 50%;
  //   transform: translateY(-100%);
  // }
  .empty-icon {
    font-size: 64px;
    color: $--color-font-light;
  }
  span {
    display: block;
    font-size: 12px;
    color: $--color-font-light;
    line-height: 1;
  }
  // .svg-icon {
  //   font-size: 72px;
  //   // color: $--svg-assist;
  //   // fill: $--svg-assist;
  // }
   .svg-icon {
    height: 207px;
    width: 207px;
  }
}
</style>
